'use client';

import { type FC } from 'react';
import { cn, RectangleButton } from '@yanolja-rnd/nol-design-system';
import { waitUntilClickTimeout } from '@weberus/utils';

export interface ShowAllButtonProps {
  boldTitle?: string | null;
  title: string;
  href: string;
  className?: string;
  onClick?: () => void;
}

export const ShowAllButton: FC<ShowAllButtonProps> = ({ boldTitle, title, href, className, onClick }) => {
  const onClickHandler = async () => {
    try {
      await waitUntilClickTimeout(onClick?.());
    } finally {
      window.location.href = href;
    }
  };

  const titleArea = (
    <>
      {!!boldTitle && <span className="typography-body-14-bold pc:typography-subtitle-16-bold">{boldTitle}&nbsp;</span>}
      <span className="typography-body-14-regular pc:typography-subtitle-16-regular">{title}</span>
    </>
  );

  return (
    <div className={cn('mt-16 flex px-16 pc:mt-24 pc:flex pc:w-pc-size pc:justify-center', className)}>
      {/* mobile only */}
      <RectangleButton className="w-full pc:hidden" theme="outlined_basic" weight="regular" onClick={onClickHandler}>
        {titleArea}
      </RectangleButton>
      {/* pc only */}
      <RectangleButton
        className="hidden w-full pc:inline-flex pc:max-w-legacy-pc-size"
        theme="outlined_secondary"
        weight="regular"
        onClick={onClickHandler}>
        {titleArea}
      </RectangleButton>
    </div>
  );
};
